<template>
  <div ref="content"></div>
</template>
<script>
export default {
  inject: ['authConfig'],
  props: {
    openId: {
      type: String,
      default: 'ou_e0bea6fdfea45e13b602d87d3d2051dc'
    }
  },
  watch: {
    authConfig: function(value) {
      if (value) {
        this.render();
      }
    }
  },
  methods: {
    render() {
      window.webComponent.render(
        'UserProfile',
        {
          openId: this.openId // 要展示哪个用户的成员名片
        },
        this.$refs.content
      );
    }
  },
  mounted() {
    if (this.authConfig.isAuth) {
      this.render();
    }
  }
};
</script>
